import { Link } from 'react-router-dom';
// import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Typed from 'react-typed';
import SliderComponent from './SliderComponent';
import Logo from '../assets/images/Logo.svg';

function Home() {
  return (
    <>
      <div className='home'>
        {/* <Container fluid> */}
          <Row>
            <Col md={6}>
              <div className='logo'>
                <img src={Logo} alt='Quantum logo' />
              </div>
              <div className='text-left'>
                <div className='slogan'>CONSIDER:</div>
                <div className='headline'>
                  Could your {''}
                  <Typed
                    strings={['water', 'fish']}
                    typeSpeed={500}
                    backSpeed={50}
                    loop
                  />
                  {''} <br />
                  be contaminated with <br />
                  PFAS chemicals?
                </div>
                <div className='text'>
                  PFAS are human-made chemicals, and the most common way to
                  consume them is through our water and food.
                </div>
                <Link to='/map'>
                  <button className='pfas-btn-blue'>Start presentation</button>
                </Link>
              </div>
            </Col>
            <Col md={6}>
              {' '}
              <div className='image-right'>
                <SliderComponent />
              </div>
            </Col>
          </Row>
        {/* </Container> */}
      </div>
    </>
  );
}

export default Home;
